import angular from 'angular';
import { isNaN } from 'lodash';

module.exports = angular.module('common.services.blank', [])
.factory('isBlank', function() {
  return function(val) {
    return val === undefined || val === Infinity || val === null || val === '' || isNaN(val);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/blank.js
 **/